<template>
  <div>
    <MenuPos />
    <div class="d-flex justify-space-between mb-2">
      <div class="d-flex justify-center align-center">
        <div class="img_header_sale_report_day">
          <img src="@/assets/icon-restaurant-mini-chart.png">
        </div>
        <h2 class="header_sale_report_day">รายงานประจำวัน</h2>
      </div>

      <!-- <v-btn color="success" height="50" width="20%" @click="$router.push('/restaurant')">
          ย้อนกลับ
      </v-btn> -->
    </div>
    <v-slide-x-reverse-transition>
      <v-alert type="warning" class="alert_success" v-if="alert_print_bill_slip === true">กำลังทำการพิมพ์รายงานกรุณารอสักครู่...</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="d-flex mb-2 title_sale_report_day">
        <div>รายงานยอดขายประจำวัน</div>
        <div>วันที่ {{ new Date().getDate() }}/{{ $store.state.monthList[new Date().getMonth()].name_short }}/{{ new Date().getFullYear() + 543 }}</div>
      </div>
      <!-- <div class="mb-3 print_sale_report_day">
          <v-btn class="grad-primary-bg white--text" width="100%" height="50" @click="printBillSlip()">พิมพ์รายงาน Bill Slip</v-btn>
      </div> -->
      <h3>หน้าร้าน</h3>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1 border_sale_report_day">
          <div class="pa-3">
            <div>ยอดขาย</div>
            <div class="text-right titlefont_sale_report_day">{{ Intl.NumberFormat().format(total_sale) }}</div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1 border_sale_report_day">
          <div class="pa-3">
            <div>จำนวนลูกค้า</div>
            <div class="text-right titlefont_sale_report_day">{{ Intl.NumberFormat().format(total_order) }}</div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between">
              <div>บุฟเฟ่ต์</div>
              <div>{{ Intl.NumberFormat().format(sale_buffet) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>ไม่บุฟเฟ่ต์</div>
              <div>{{ Intl.NumberFormat().format(sale_notbuffet) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>ซื้อกลับบ้าน</div>
              <div>{{ Intl.NumberFormat().format(sale_takehome) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>อื่นๆ</div>
              <div>{{ Intl.NumberFormat().format(sale_other) }}</div>
            </div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between">
              <div>บุฟเฟ่ต์</div>
              <div>{{ Intl.NumberFormat().format(order_buffet) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>ไม่บุฟเฟ่ต์</div>
              <div>{{ Intl.NumberFormat().format(order_nobuffet) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>ซื้อกลับบ้าน</div>
              <div>{{ Intl.NumberFormat().format(order_takehome) }}</div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="30%" class="mr-1">
          <div class="pa-3">
            <div>การรับเงิน</div>
            <v-card class="mb-3 border_sale_report_day">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report_day">{{ Intl.NumberFormat().format(pay_in_cash) }}</div>
                <div>เงินสด</div>
              </div>
            </v-card>
            <v-card class="mb-3 border_sale_report_day">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report_day">{{ Intl.NumberFormat().format(pay_in_cash_transfer) }}</div>
                <div>เงินโอน</div>
              </div>
            </v-card>
            <v-card class="mb-3 border_sale_report_day">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report_day">{{ Intl.NumberFormat().format(pay_in_cash_credit) }}</div>
                <div>เครดิต</div>
              </div>
            </v-card>
            <v-card class="mb-3 border_sale_report_day">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report_day">{{ Intl.NumberFormat().format(person_half) }}</div>
                <div>โครงการ คนละครึ่ง</div>
              </div>
            </v-card>
            <v-card class="border_sale_report_day">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report_day">{{ Intl.NumberFormat().format(blue_flag) }}</div>
                <div>โครงการ ร้านธงฟ้า</div>
              </div>
            </v-card>
          </div>
        </v-card>
        <v-card width="70%" class="ml-1">
          <div class="pa-3">
            <canvas id="my-chart"></canvas>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="100%">
          <div class="d-flex justify-space-between pa-3">
            <div>สรุปยอดเงินสดในระบบ</div>
            <div>{{ Intl.NumberFormat().format(cash_total) }}</div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="d-flex justify-space-between pa-3">
            <div>เงินสดเปิดลิ้นชัก</div>
            <div>{{ Intl.NumberFormat().format(money_open) }}</div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="d-flex justify-space-between pa-3">
            <div>เงินสดปิดลิ้นชัก</div>
            <div>{{ Intl.NumberFormat().format(money_close) }}</div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="d-flex justify-space-between pa-3">
            <div>เงินสดส่วนต่าง</div>
            <div>{{ Intl.NumberFormat().format(lost_cash) }}</div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="d-flex justify-space-between pa-3">
            <div>เหตุผล</div>
            <div>{{ description }}</div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between align-center">
              <div>จำนวนลูกค้าทานที่ร้าน</div>
              <div class="titlefont_sale_report_day">{{ Intl.NumberFormat().format(customer_in_restaurant) }}</div>
            </div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between align-center">
              <div>จำนวนลูกค้าซื้อกลับบ้าน</div>
              <div class="titlefont_sale_report_day">{{ Intl.NumberFormat().format(customer_buy_takehome) }}</div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between align-center">
              <div>ยอดขายเฉลี่ยต่อลูกค้า</div>
              <div class="titlefont_sale_report_day">{{ avg_to_customer }}</div>
            </div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between align-center">
              <div>ยอดขายเฉลี่ยต่อออเดอร์</div>
              <div class="titlefont_sale_report_day">{{ avg_to_order }}</div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="mb-3">
        <v-card>
          <div class="pa-3">
            <h3>เดริเวอร์รี่</h3>
            <v-simple-table>
              <thead>
              <tr>
                <th class="text-center border_header_sale_report_day">
                  ชื่อ
                </th>
                <th class="text-center border_header_sale_report_day">
                  ยอดขาย (บาท)
                </th>
                <th class="text-center border_header_sale_report_day">
                  ส่วนลด (บาท)
                </th>

                <th class="text-center border_header_sale_report_day">
                  รายได้ก่อนหักค่าบริการ
                </th>
                <th class="text-center border_header_sale_report_day">
                  ค่าบริการ และ Vat
                </th>
                <th class="text-center border_header_sale_report_day">
                  รายได้สุทธิ
                </th>
                <th class="text-center border_header_sale_report_day">
                  เงินรับเข้า
                </th>
                <th class="text-center border_header_sale_report_day">
                  รายได้ค้างรับ
                </th>
              </tr>

              </thead>
              <tbody>
              <tr v-for="(delivery_detail,index) in delivery_list" :key="index">
                <td class="text-center border_header_sale_report_day">
                  {{ delivery_detail.debtor_name }}
                </td>
                <td class="text-center border_header_sale_report_day">
                  {{ delivery_detail.sale }}
                </td>
                <td class="text-center border_header_sale_report_day">
                  {{ delivery_detail.discount }}
                </td>
                <td class="text-center border_header_sale_report_day">
                  {{ delivery_detail.income_before_deductions }}
                </td>
                <td class="text-center border_header_sale_report_day">
                  {{ delivery_detail.service_vat }}
                </td>
                <td class="text-center border_header_sale_report_day">
                  {{ delivery_detail.total_price }}
                </td>
                <td class="text-center border_header_sale_report_day">
                  {{ delivery_detail.income_price }}
                </td>
                <td class="text-center border_header_sale_report_day">
                  {{ delivery_detail.accrued_income }}
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card>
      </div>
      <!-- <div class="d-flex justify-end">
          <v-btn width="50%" height="70px" @click="$router.push('/salestatistic')">
              <div class="d-flex justify-center align-center">
                  <div class="img_link_statistic_sale_report_day">
                      <img src="@/assets/fast-food.png">
                  </div>
                  <div>ดูสถิติยอดขายอาหาร</div>
              </div>
          </v-btn>
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  HTTP
} from "@/axios.js"
import MenuPos from '@/components/menuadmin/MenuPos.vue'
import Chart from 'chart.js'
// import 'chartjs-plugin-labels'
export default {
  name: 'saleReportDay',
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  components: {
    MenuPos,
  },
  data() {
    return {
      loading_page: true,
      alert_print_bill_slip: false,
      sale_report_day_id: null,
      cash_total: 0,
      money_open: 0,
      money_close: 0,
      lost_cash: 0,
      description: null,
      total_sale: 0,
      sale_buffet: 0,
      sale_notbuffet: 0,
      sale_takehome: 0,
      sale_other: 0,
      total_order: 0,
      order_buffet: 0,
      order_nobuffet: 0,
      order_takehome: 0,
      pay_in_cash: 0,
      pay_in_cash_transfer: 0,
      pay_in_cash_credit: 0,
      person_half:0,
      blue_flag:0,
      customer_in_restaurant: 0,
      customer_buy_takehome: 0,
      avg_to_customer: 0,
      avg_to_order: 0,
      delivery_list: [],
      name_list: [],
      total_price_list: [],
      color_list: [],
    }
  },
  methods: {
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    async chartAll() {
      this.color_list = [];
      this.loading_page = true
      await HTTP.get('/POS/report-day', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
          .then((response) => {
            if (response.data.successful === true) {
              this.sale_report_day_id = response.data.report.id
              this.cash_total = response.data.report.cash_total
              this.money_open = response.data.report.money_open
              this.money_close = response.data.report.money_close
              this.lost_cash = response.data.report.lost_cash
              this.description = response.data.report.reason
              this.total_sale = response.data.report.total_sale
              this.sale_buffet = response.data.report.sale_buffet
              this.sale_notbuffet = response.data.report.sale_nobuffet
              this.sale_takehome = response.data.report.sale_takehome
              this.sale_other = response.data.report.sale_other

              this.total_order = response.data.report.total_order
              this.order_buffet = response.data.report.order_buffet
              this.order_nobuffet = response.data.report.order_nobuffet
              this.order_takehome = response.data.report.order_takehome

              this.pay_in_cash = response.data.report.cash
              this.pay_in_cash_transfer = response.data.report.cash_transfer
              this.pay_in_cash_credit = response.data.report.cash_credit
              this.person_half = response.data.report.person_half
              this.blue_flag = response.data.report.blue_flag

              this.customer_in_restaurant = response.data.report.customer_in_restaurant
              this.customer_buy_takehome = response.data.report.customer_buy_takehome
              this.avg_to_customer = response.data.report.avg_to_customer
              this.avg_to_order = response.data.report.avg_to_order

              this.delivery_list = response.data.delivery
              this.name_list = response.data.report.arr_name
              this.total_price_list = response.data.report.arr_price
              this.total_price_list.forEach(() => {
                this.color_list.push(this.getRandomColor())
              })

              this.loading_page = false
            }

            if (response.data.successful === false) {
              this.alert_error = true
            }

          }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })

      let ctx = document.getElementById('my-chart')
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.name_list,
          datasets: [{
            data: this.total_price_list,
            backgroundColor: this.color_list,
          }]
        },
        options: {
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            labels: {
              render: 'value',
              fontColor: ['#000000'],
              precision: 2
            }
          },
          scales: {
            yAxes: [{
              ticks: {
                max: parseInt(Math.max(...this.total_price_list)) + 1000,
                beginAtZero: true
              }
            }]
          },
        }
      })
    },
    async printBillSlip() {
      HTTP.post('/POS/change_status_static/' + this.sale_report_day_id, null, {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
          .then((response) => {
            if (response.data.successful === true) {
              this.alert_print_bill_slip = true
              setTimeout(() => this.alert_print_bill_slip = false, 5000)
            }

            if (response.data.successful === false) {
              this.alert_error = true
            }

          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    }
  },
  mounted() {
    this.chartAll()
  }
}
</script>

<style scoped>
.border_header_sale_report_day {
  border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
